import { Component } from '../../../types/elearning';
import TextBlockViewer from './TextBlockViewer';
import HeadingBlockViewer from './HeadingBlockViewer';
import ImageBlockViewer from './ImageBlockViewer';
import VideoBlockViewer from './VideoBlockViewer';
import ColumnsViewer from './ColumnsViewer';
import CardViewer from './CardViewer';
import KnowledgeCheckViewer from './KnowledgeCheckViewer';
import ResourceViewer from './ResourceViewer';
import TableViewer from './TableViewer';
import AccordionViewer from './AccordionViewer';
import CalloutViewer from './CalloutViewer';

interface ComponentRendererProps {
  component: Component;
}

export default function ComponentRenderer({ component }: ComponentRendererProps) {
  switch (component.type) {
    case 'text':
      return <TextBlockViewer content={component.content as any} />;
    case 'heading':
      return <HeadingBlockViewer content={component.content as any} />;
    case 'image':
      return <ImageBlockViewer content={component.content as any} />;
    case 'video':
      return <VideoBlockViewer content={component.content as any} />;
    case 'columns':
      return <ColumnsViewer content={component.content as any} />;
    case 'card':
      return <CardViewer content={component.content as any} />;
    case 'knowledge-check':
      return <KnowledgeCheckViewer content={component.content as any} />;
    case 'resource':
      return <ResourceViewer content={component.content as any} />;
    case 'table':
      return <TableViewer content={component.content as any} />;
    case 'accordion':
      return <AccordionViewer content={component.content as any} />;
    case 'callout':
      return <CalloutViewer content={component.content as any} />;
    default:
      return (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
          <p className="text-sm text-yellow-800">
            Unknown component type: "{component.type}"
          </p>
        </div>
      );
  }
}

